import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../../routes';
import { TableRowSelect } from './tr-select';
import { TableRowInput } from './tr-input';
import { Switch } from './Switch';
export default class TableGeneral extends Component {
     
    constructor(props) {
        super(props);
        this.state = { 
            baseUrl: document.getElementById('baseUrl').value,
        };
    }

    render() {

        const { baseUrl } = this.state;
        const { empresas, cadenas, general, versiones, onChangeInputTableGeneral,onSaveParamsCadena, onChangeInputTableImagen, onChange, regimenFiscales } = this.props;
        const optionsCadena = cadenas.map((item, index) => <option key={index} value={item.Id}>{item.Nombre}</option>);
        const optionsEmpresa = empresas.map((item, index) => <option key={index} value={item.Id}>{item.Nombre}</option>);
        const onCheked = general.General_Site_Interno === "SI" ? true : false;
        
        return(
            <div className="table-responsive">
                <table className="table table-sm">
                    <tbody>
                       
                        <TableRowInput   title="Ajuste de Horario"
                                            type="text"
                                            name="General_Ajuste_Horario"
                                            value={general.General_Ajuste_Horario}
                                            onChange={onChangeInputTableGeneral}
                         />
                        <TableRowSelect title="Empresa"
                            options={optionsEmpresa}
                            name="empresa"
                            value={general.General_Empresa}
                            onChange={onChange}
                        />                        
                        <TableRowSelect title="Cadena"
                            options={optionsCadena}
                            name="cadena"
                            value={general.General_Cadena}
                            onChange={onChange}
                        />
                        <tr>
                            <td><b>Site Interno</b></td>
                            <td colSpan="2">
                                <Switch
                                    cheked={onCheked}
                                    onLabel="SI"
                                    offLabel="NO"
                                    onChange={onchange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                {/*<button type="button" className="btn btn-custom-theme float-right"><i className="far fa-save" onClick={onSaveParamsGeneral}></i></button>*/}
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right">
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tabla-general.jsx